import "../css/Dashboard.css";
import PlansSection from "./PlansSection";

function ManagePlans()
{
    return(
        <div>

        <PlansSection/>

        </div>
    )
}

export default ManagePlans;